<!--
 * @Author: zhujuan
 * @Date: 2022-01-17 14:59:41
 * @LastEditors: zhujuan
 * @LastEditTime: 2022-01-25 17:18:12
 * @Description: 
 * @FilePath: /nqc-pc-ui/src/common/components/WnTable/index.vue
-->
<template>
  <div class="wn-table-template__content">
    <slot />

    <w-pagination
      v-if="listQuery.pageNum"
      slot="footer"
      class="wn-fr"
      :current-page="listQuery.pageNum"
      :page-size="listQuery.pageSize"
      :total="listQuery.total"
      :pager-count="5"
      :layout="listQuery.layout || 'total, prev, pager, next'"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  props: {
    listQuery: {
      // 条件
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 50,
          total: 0
        }
      }
    }
  },
  data() {
    return {
      pageSize: 10
    }
  },
  mounted() {},

  created() {},

  methods: {
    handleCurrentChange(val) {
      const listQuery = this.listQuery
      listQuery.pageNum = val
      this.$emit('update:listQuery', listQuery)
      this.$emit('fetchData')
    }
  }
}
</script>
<style lang="scss" scoped>
.wn-table-template__content {
  .w-pagination-wrapper {
    padding-top: 10px;
  }
}
</style>
